export default __webpack_public_path__ + "static/media/facebook.d513d944.svg";